export async function sleep(ms: number) {
  return new Promise((r) => setTimeout(r, ms));
}

export const OneSecondMs = 1000;
export const OneMinuteMs = OneSecondMs * 60;
export const OneHourMs = OneMinuteMs * 60;
export const OneDayMs = OneHourMs * 24;
